import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/layout'

Vue.use(Router)

const fucFiles = require.context('./modules', false, /\.js$/)
const routerList = []
fucFiles.keys().forEach(key => {
  routerList.push(fucFiles(key).default || fucFiles(key))
})


let router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'layout',
      meta: { title: 'Home', noCache: true, affix: true },
      component: Layout,
      redirect: '/dashboard'
    },
    {
      path: '/forgetWord',
      name: 'forgetWord',
      // meta: { title: 'forgetWord', noCache: true, affix: true },
      component: () => import('@/views/login/forgetWord'),
    },
    {
      path: '/login',
      name: 'Login',
      meta: { title: 'Login', noCache: true, affix: true },
      component: () => import('@/views/login/login'),
    },
    {
      path: '/404',
      component: () => import('@/views/error-page/404'),
      hidden: true
    },
    ...routerList
  ]
})
router.beforeEach((to, from, next) => {
  console.log(to);
  // 1.如果访问的是登录页面（无需权限），直接放行
  if (to.path === '/login'||to.path==='/forgetWord') return next()
  // 2.如果访问的是有登录权限的页面，先要获取token
  const tokenStr = window.localStorage.getItem('token')
  // 2.1如果token为空，强制跳转到登录页面；否则，直接放行
  if (!tokenStr) return next('/login')
  if (to.matched.length === 0) {
    next('/404') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
  }
  next()
})

export default router